<div class="container">
  <span class="container__title">{{ 'driverLicenseHint.wherFindNumber' | translate }}</span>
  <span class="container__label">{{ 'driverLicenseHint.physicalDocument' | translate }}:</span>
  <div class="container__image">
    <img src="/assets/img/driver-license-hint.png" alt="driver license hint">
  </div>

  <span style="margin-top: 1rem;" class="container__label">{{'driverLicenseHint.mObywatelApp'|translate}}:</span>
  <div class="container__image">
    <img src="/assets/img/driver-license-hint-mObywatel.png" alt="">
  </div>

  <span class="container__description">
    {{'driverLicenseHint.description'|translate}}
  </span>
</div>

